import React from 'react';
import ManageUser from '../../../Admin/manageUser';

export default function ManageUsers() {
  return <ManageUser />;
}
